module.exports = __webpack_public_path__ + "static/media/1.28a73dca.JPG";